import PlayIcon from "@/components/icons/PlayIcon.vue";
import PauseIcon from "@/components/icons/PauseIcon.vue";
import AlertOctagon from "@/components/icons/AlertOctagon.vue";
export default {
  name: "PpcInconsistentStatePopover",
  emits: ["pause-all", "enable-all"],
  components: {
    PlayIcon,
    PauseIcon,
    AlertOctagon
  },
  props: {
    type: {
      type: String,
      default: "campaigns"
    }
  }
};